exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".moving-average-benchmark .custom .dials {\n  display: flex;\n  flex-direction: row; }\n  .moving-average-benchmark .custom .dials > * {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 0 1rem; }\n    .moving-average-benchmark .custom .dials > *:first-child {\n      padding-left: 0; }\n    .moving-average-benchmark .custom .dials > *:last-child {\n      padding-right: 0; }\n", ""]);

// exports
